export enum CancelCardStage {
  CancelCard = 'CancelCard',
}

export interface CancelCardState {
  stage: CancelCardStage.CancelCard
  cardId: string
}
